module.exports = __webpack_public_path__ + "static/media/cover2.79a40bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover2.png
// module id = 555
// module chunks = 0